import { type IconProps } from '../iconProps';

export const Settings: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.325 20L7.9 16.975C7.63333 16.875 7.3875 16.7542 7.1625 16.6125C6.9375 16.4708 6.71667 16.3167 6.5 16.15L3.7 17.325L1.725 13.875L4.15 12.025C4.13333 11.8917 4.125 11.7625 4.125 11.6375V10.3625C4.125 10.2375 4.13333 10.1083 4.15 9.975L1.725 8.125L3.7 4.675L6.5 5.85C6.71667 5.68333 6.9375 5.52917 7.1625 5.3875C7.3875 5.24583 7.63333 5.125 7.9 5.025L8.325 2H12.275L12.7 5.025C12.9667 5.125 13.2125 5.24583 13.4375 5.3875C13.6625 5.52917 13.8833 5.68333 14.1 5.85L16.9 4.675L18.875 8.125L16.45 9.975C16.4667 10.1083 16.475 10.2375 16.475 10.3625V11.6375C16.475 11.7625 16.4583 11.8917 16.425 12.025L18.85 13.875L16.875 17.325L14.1 16.15C13.8833 16.3167 13.6625 16.4708 13.4375 16.6125C13.2125 16.7542 12.9667 16.875 12.7 16.975L12.275 20H8.325ZM10.3 13.5C11.25 13.5 12.0625 13.1625 12.7375 12.4875C13.4125 11.8125 13.75 11 13.75 10.05C13.75 9.1 13.4125 8.2875 12.7375 7.6125C12.0625 6.9375 11.25 6.6 10.3 6.6C9.33333 6.6 8.51667 6.9375 7.85 7.6125C7.18333 8.2875 6.85 9.1 6.85 10.05C6.85 11 7.18333 11.8125 7.85 12.4875C8.51667 13.1625 9.33333 13.5 10.3 13.5Z'
        fill={fill}
      />
    </svg>
  );
};
